export default __webpack_public_path__ + "static/media/other_bank_light.8679a8fc.png";